<template>
  <div class="w-full h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <!-- 搜索框 -->
      <el-row type="flex" align="middle">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-input
          size="small"
          v-model.trim="mainTableParam.keyword"
          @keyup.native.enter="getDynamicTableResult('search')"
          :placeholder="`${$t('SearchForAssetEncodingsAndAssetNames')}`"
          clearable
          data-cy="inputSearch"
          class="w-200px mr-10px ml-10px"
        ></el-input>
        <el-select
          v-model="tagSearchNameList"
          :placeholder="`${$t('SearchForAssetCategories')}`"
          size="small"
          class="!w-500px mr-10px"
          multiple
          clearable
          filterable
          :filter-method="getParentTypeList"
          collapse-tags
          popper-class="tag_select-popper"
          ref="tagSearchSelect"
          @remove-tag="removeTagSearchTag"
          @clear="clearTagSearchTag"
        >
          <el-option :label="tagSearchName" :value="searchTagClassIds">
            <el-tree
              :data="tagTreeData"
              :props="classTreeProps"
              node-key="id"
              @node-click="handleSearchTagTreeClick"
              :expand-on-click-node="false"
            >
              <div
                slot-scope="{ node, data }"
                class="text-14px h-full tree-node"
                style="line-height: 24px; width: calc(100% - 40px)"
              >
                <span :class="{ 'text-blue': searchTagClassIds.includes(data.id) }">
                  {{ data.code }}({{ node.label }})
                </span>
                <i
                  v-if="searchTagClassIds.includes(data.id)"
                  class="el-icon-check text-blue font-bold"
                ></i>
              </div>
            </el-tree>
          </el-option>
        </el-select>
        <el-button type="primary" data-cy="searchBtn" @click="getDynamicTableResult('search')">{{
          $t('search')
        }}</el-button>
        <el-button :disabled="!$hasAccess('delete')" type="danger" @click="removeTagList(tagIds)">{{
          $t('disassociate')
        }}</el-button>
        <el-button :disabled="!$hasAccess('export')" @click="exportExcel" :loading="excelLoading">
          {{ $t('export') }}
        </el-button>
        <el-button :disabled="!$hasAccess('import')" @click="importFile">
          {{ $t('import') }}
        </el-button>
        <!-- <columnVisible
          :options="columnVisibleOptions"
          class="dib ml-10px"
          :name="['handoverTag']"
          :defaultValue="columnVisible"
          @columnVisibleChanged="handleColumnVisibleChanged"
        ></columnVisible> -->
      </el-row>
      <!-- 表格 -->
      <el-col :span="24" style="height: calc(100% - 104px)" class="mt-20px">
        <div style="height: 100%">
          <el-table
            border
            v-loading="tagListLoading"
            :data="tagListTable"
            @sort-change="sortChange"
            @selection-change="getIdArray"
            @row-dblclick="dbClickRow"
            ref="multipleTable"
            height="100%"
            stripe
            data-cy="tagListTable"
            row-key="id"
          >
            <el-table-column
              v-if="tableHeader.length > 0"
              fixed
              :reserve-selection="true"
              type="selection"
              width="40"
            ></el-table-column>
            <el-table-column
              v-for="(val, index) in tableHeader"
              :key="index"
              :prop="`${val.tableName}.${val.columnName}`"
              sortable="custom"
              :label="val.name"
              show-overflow-tooltip
              min-width="150"
            >
              <template slot-scope="scope">
                <div class="truncate">
                  {{ scope.row[`${val.tableName}.${val.columnName}`]
                  }}<span v-if="val.unit">{{ val.unit }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="`${$t('operate')}`"
              key="edit"
              width="180"
              v-if="tableHeader.length > 0"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="openTagListDialog(scope.row)"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="removeTagList([scope.row.id])"
                  >{{ $t('disassociate') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <!-- 分页器 -->
      <el-pagination
        background
        @size-change="getDynamicTableResult('sizeChange')"
        @current-change="getDynamicTableResult"
        :current-page.sync="mainTableParam.pageno"
        :page-size.sync="mainTableParam.pagesize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        class="float-right mt-20px"
      ></el-pagination>
    </el-card>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getDynamicTableResult('search')"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
    <!-- 编辑 -->
    <HandoverFormDialog
      v-if="handoverFormProps.dialogVisible"
      :handoverFormProps="handoverFormProps"
      @handoverFormEmit="handoverFormEmit"
    />
  </div>
</template>

<script>
import TagService from '@/services/tags'
import DocumentManagementService from '@/services/documentManagement'
import stdClassListService from '@/services/stdClassListService'
import associatedObjectsService from '@/services/associatedObjectsService'
import fnMixin from '@/assets/js/fnMixins'
// import columnVisible from '@/components/ColumnVisible'
import selectStandardId from '../../components/selectStandardId'
import HandoverFormDialog from '../../components/handoverFormDialog'

export default {
  components: {
    // columnVisible,
    selectStandardId,
    HandoverFormDialog,
  },
  mixins: [fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      standardId: localStorage.getItem('standardId'),
      // 主表格参数
      mainTableParam: {
        keyword: '',
        pageno: 1,
        pagesize: 15,
        tagclassids: '',
      },
      tagSearchNameList: [],
      tagSearchName: '',
      searchTagClassIds: [],
      tagTreeData: [],
      classTreeProps: { label: 'name', children: 'children' },
      // 显示列
      columnVisible: ['code', 'name', 'className', 'createdTime', 'lastModifiedTime'],
      columnVisibleOptions: [
        {
          value: 'code',
          label: 'Code',
        },
        {
          value: 'name',
          label: 'Name',
        },
        {
          value: 'className',
          label: 'category',
        },
        {
          value: 'parentName',
          label: 'ParentObject',
        },
        {
          value: 'flagName',
          label: 'state',
        },
        {
          value: 'longDescription',
          label: 'LongDescription',
        },
        {
          value: 'shortDescription',
          label: 'ShortDescription',
        },
        {
          value: 'createdTime',
          label: 'CreationTime',
        },
        // {
        //   value: 'createdUser',
        //   label: 'CreateAUser',
        // },
        {
          value: 'lastModifiedTime',
          label: 'LastModifiedTime',
        },
        // {
        //   value: 'lastModifiedUser',
        //   label: 'LastModifyTheUser',
        // },
      ],
      tagListLoading: false,
      tagListTable: [],
      sortName: '', // 排序的字段
      sortType: '', // 排序的方式 asc为升序, desc为降序
      isPrStyle: false, // 操作按钮列宽
      totalCount: 0,
      excelLoading: false,
      currentRow: {}, // 当前行
      selectionList: [],
      tagIds: [],
      tableHeader: [],
      handoverFormProps: {
        dialogVisible: false, // form弹框显示状态
        standardId: localStorage.getItem('standardId'),
        tabs: [
          // form弹框tab显示
          { name: '位号', label: '1' },
          // { name: '关联关系', label: '3' },
        ],
        rowData: null,
        isShowClassType: true,
      },
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.mainTableParam.tagclassids = ''
        this.tagSearchName = ''
        this.searchTagClassIds = []
        this.tagSearchNameList = []
        // this.initListTable('search')
        this.getDynamicTableHeaders()
        this.getDynamicTableResult()
        this.getParentTypeList()
      }
    },
  },
  methods: {
    // 编辑弹框子组件传参
    handoverFormEmit(val) {
      if (val) {
        this.handoverFormProps.dialogVisible = val.dialogVisible
        this.getDynamicTableResult()
      }
    },
    // 动态获取表头
    async getDynamicTableHeaders() {
      const res = await TagService.getDynamicTableHeaders({
        standardId: this.standardId,
        code: 'Tag',
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      } else {
        this.tableHeader = []
      }
    },
    // 动态获取列表数据
    async getDynamicTableResult(type) {
      this.totalSelection = []
      if (type === 'search') {
        this.mainTableParam.pageno = 1
      }
      if (_.isEmpty(this.searchTagClassIds)) {
        delete this.mainTableParam.tagclassids
      } else {
        this.mainTableParam.tagclassids = this.searchTagClassIds
      }
      this.tagListLoading = true
      const res = await TagService.getDynamicTableResult({
        standardId: this.standardId,
        skipCount: this.mainTableParam.pageno,
        maxResultCount: this.mainTableParam.pagesize,
        sorting: `${this.sortName} ${this.sortType}`,
        cateCode: 'Tag',
        filter: this.mainTableParam.keyword,
        classIds: this.mainTableParam.tagclassids,
      })
      this.tagListLoading = false
      if (res && res.code === 0 && res.data) {
        this.tagListTable = res.data
        this.totalCount = res.totalCount
      } else {
        this.tagListTable = []
        this.totalCount = 0
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await associatedObjectsService.downloadTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '关联对象导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await associatedObjectsService.import(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '关联对象导入明细.xlsx',
          data: res,
        })
        this.getDynamicTableResult('search')
      }
      this.uploadFileProps.btnLoading = false
    },
    updateStandardId(val) {
      this.standardId = val
    },
    handleSearchTagTreeClick(node) {
      if (!_.includes(this.searchTagClassIds, node.id)) {
        this.searchTagClassIds.push(node.id)
        this.tagSearchName = node.name
        this.tagSearchNameList.push({
          name: node.name,
          id: node.id,
        })
      } else {
        const num = this.searchTagClassIds.findIndex((item) => {
          return item === node.id
        })
        if (num === this.searchTagClassIds.length - 1 && num > 0) {
          this.tagSearchName = this.tagSearchNameList[num - 1].name
        } else if (num === 0 && this.searchTagClassIds.length === 1) {
          this.tagSearchName = null
        } else {
          this.tagSearchName = this.tagSearchNameList[num + 1].name
        }
        this.searchTagClassIds.splice(num, 1)
        this.tagSearchNameList.splice(num, 1)
      }
    },
    clearTagSearchTag() {
      this.searchTagClassIds = []
    },
    removeTagSearchTag() {
      this.searchTagClassIds = _.map(this.tagSearchNameList, (el) => {
        return el.id
      })
    },
    // 初始化表格
    async initListTable(type) {
      if (type === 'search') {
        this.mainTableParam.pageno = 1
      }
      if (_.isEmpty(this.searchTagClassIds)) {
        delete this.mainTableParam.tagclassids
      } else {
        this.mainTableParam.tagclassids = this.searchTagClassIds.join(',')
      }
      const params = {
        StandardId: this.standardId,
        SkipCount: this.mainTableParam.pageno,
        MaxResultCount: this.mainTableParam.pagesize,
        Keyword: this.mainTableParam.keyword,
        Sorting: `${this.sortName} ${this.sortType}`,
        StdClassId: this.mainTableParam.tagclassids,
      }
      this.tagListLoading = true
      const res = await DocumentManagementService.getTagList(params)
      this.tagListLoading = false
      if (res && res.code === 0 && res.data) {
        this.tagListTable = res.data
        this.totalCount = res.totalCount
      }
    },
    // 排序
    sortChange(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.sortName = row.prop
      this.sortType = orderbytype
      this.getDynamicTableResult('search')
    },
    // 获取多选框选中的id数组
    getIdArray(val) {
      this.tagIds = []
      this.selectionList = val
      _.map(val, (item) => {
        this.tagIds.push(item.id)
      })
    },
    // 双击表格行
    async dbClickRow(row) {
      this.currentRow = row
    },
    // 获取对象类别列表
    async getParentTypeList(val) {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
        info_type: 0, // 对象
        keyword: val,
        catecode: 'Tag',
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.tagTreeData = res.data.length > 0 ? this.listToTree(res.data) : []
      }
    },
    // 列表转树
    listToTree(list) {
      // 先找出所有有效的父节点ID
      const parentIds = new Set(
        list.map((item) => {
          return item.id
        })
      )

      const result = list.reduce((prev, curr) => {
        curr.pathName = `/${curr.name}/`
        curr.children = list.filter((v) => {
          return v.parentId === curr.id
        })

        // 如果是根节点或找不到父节点,就放到第一级
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null ||
          !parentIds.has(curr.parentId)
        ) {
          prev.push(curr)
        }
        return prev
      }, [])

      return result
    },
    // 选择列表展示内容
    handleColumnVisibleChanged(val) {
      this.columnVisible = val
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout()
      })
    },
    // 文件导出
    async exportExcel() {
      let params
      if (this.selectionList.length > 0) {
        // 勾选table，传勾选的id
        const idList = []
        _.map(this.selectionList, (item) => {
          idList.push(item.id)
        })
        params = {
          tagIds: idList,
          standardId: this.standardId,
        }
      } else {
        // 没有勾选table，根据过滤条件筛选
        params = {
          standardId: this.standardId,
          keyword: this.mainTableParam.keyword,
          classId: this.mainTableParam.tagclassids,
        }
      }
      this.excelLoading = true
      const res = await associatedObjectsService.export(params)
      this.excelLoading = false
      if (res) {
        this.downLoadExcel('关联对象导出结果.xlsx', res)
      }
    },
    // 批量删除位号关联关系
    async removeTagList(tagIdList) {
      if (tagIdList.length) {
        this.$confirm(this.$t('Whethertodisassociatethedata'), `${this.$t('hint')}`, {
          confirmButtonText: `${this.$t('Sure')}`,
          cancelButtonText: `${this.$t('Cancel')}`,
          type: 'warning',
        }).then(async () => {
          const res = await associatedObjectsService.deleteTagAssoc(tagIdList)
          if (res && res.code === 0) {
            // this.$message.success('解除关联成功')
            this.$message.success(`${this.$t('successfulDeAssociation')}`)
            this.getDynamicTableResult('search')
          }
        })
      } else {
        // this.$message.warning('请选择要解除关联的数据')
        this.$message.warning(`${this.$t('selectUnassociate')}`)
      }
    },
    // 打开新增编辑弹窗
    openTagListDialog(row) {
      // this.currentRow = row
      this.handoverFormProps.rowData = row
      this.handoverFormProps.dialogVisible = true
      if (row) {
        this.handoverFormProps.tabs = [
          { name: '位号', label: '1' },
          { name: '关联关系', label: '3' },
        ]
        this.handoverFormProps.type = 'read'
      }
    },
  },
  async created() {
    if (this.standardId) {
      await this.getParentTypeList()
      // this.initListTable('search')
      this.getDynamicTableHeaders()
      this.getDynamicTableResult()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}
.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-blue {
  color: #409eff;
}

</style>
